import axios from 'axios';

export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILURE = 'FETCH_COMPANIES_FAILURE';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const fetchCompanies = () => async (dispatch) => {
  dispatch({ type: FETCH_COMPANIES_REQUEST });
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'company',
      command: 'getCompanies'
    });
    dispatch({
      type: FETCH_COMPANIES_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_COMPANIES_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch companies'
    });
  }
};

export const addCompany = (companyData) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'company',
      command: 'createCompany',
      ...companyData
    });
    dispatch({
      type: ADD_COMPANY_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompany = (companyId, updateData) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'company',
      command: 'updateCompany',
      companyId,
      updateData
    });
    dispatch({
      type: UPDATE_COMPANY_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCompany = (companyId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'company',
      command: 'deleteCompany',
      companyId
    });
    dispatch({
      type: DELETE_COMPANY_SUCCESS,
      payload: companyId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};